export default {"src":"/_next/static/media/whatsapp.79807cbe.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};